import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formSelectors from '../../../selectors/admin/forms';
import { MODELS } from '../../../constants/admin/settings';
import { onInput, reset, formSetField, setModelData, formUpdate } from '../../../actions/admin/forms';
import { setDates } from '../../../actions/admin/models/events';
import DatesSelector from '../../../components/admin/forms/events/DatesSelector';
import { submittingSelector } from '../../../selectors/admin/forms';
import { getDayIntervals, timeToMs } from '../../../lib/date.utils';
import LineupActions from '../../../components/admin/lineup/LineupActions';
import StageEditor from '../../../components/admin/lineup/StageEditor';
import { openModalForm, openModalFormWithData } from '../../../actions/admin/modal.forms';
import * as lineupActions from '../../../actions/admin/models/lineup';
import * as lineupSelectors from '../../../selectors/admin/models/lineup';
import { closeModalForm } from '../../../actions/admin/modal.forms';
import { filter, orderBy, forEach, uniqBy } from 'lodash';
import PerformancesDetails from '../../../components/admin/lineup/PerformancesDetails';
import { artistOptionsSelector } from '../../../selectors/admin/models/lineup';
import LaunchIcon from '@material-ui/icons/Launch';
import { Link } from 'react-router-dom';
import { TIMETABLE_PATH } from '../../../constants/routes';
import ActionBar from '../../../components/admin/helpers/ActionBar';
import LineupSearchResults from '../../../components/admin/lineup/LineupSearchResults';
import { blockTabSwitch, enableTabSwitch } from '../../../actions/admin/tabs';
import { fetchAllTemplates } from '../../../actions/admin/models/templates';
import { fetchArtistContactDependencies } from '../../../actions/admin/models/artists';
import { contextSubjectSelector } from '../../../selectors/admin/context';
import ListView from '../../../components/application/timetable/ListView';
import { accessToClearance, currentUserSelector } from '../../../selectors/authentication';
import AdminModalForm from '../AdminModalForm';
import BulkPerformancesInput from '../../../components/admin/forms/bulk/BulkPerformancesInput';
import { bulkUpdatePerformances, fetchBulkPerformancesDependency } from '../../../actions/admin/models/bulk';
import Loading from '../../../components/helpers/Loading';

class LineupEditor extends Component {
    state = { showDatesForm: false, search: '', selectedDay: false, showPerformanceDetails: false };
    componentDidMount() {
        this.setState({
            showDatesForm: this.props.event.id && (!this.props.event.start || !this.props.event.end),
            selectedDay: (getDayIntervals(this.props.event.start, this.props.event.end)[0] || {}).fullDate
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.event.start !== this.props.event.start || prevProps.event.end !== this.props.event.end) {
            this.setState({
                selectedDay: (getDayIntervals(this.props.event.start, this.props.event.end)[0] || {}).fullDate
            });
        }
        if (prevState.showPerformanceDetails === false && this.state.showPerformanceDetails === true) {
            this.props.formSetField(false, 'fetched');
        }
    }
    // DATES
    _selectDate = (val, name) => this.props.onInput(MODELS.EVENT, name, val);
    _setDates = () => this.props.setDates(this.props.event);
    _toggleEditDatesMode = () => this.setState({ showDatesForm: !this.state.showDatesForm });
    _switchDay = d => {
        this.setState({ selectedDay: d });
        this.props.clearPerformancesSelection();
    };
    // STAGES
    _openStageForm = stage => {
        if (stage.id) {
            const data = lineupSelectors.stageToForm(stage, this.props.stages);
            this.props.openModalFormWithData(MODELS.STAGE, data);
        } else {
            this.props.openModalForm();
        }
    };
    _stages = () =>
        orderBy(
            filter(this.props.stages, x => x.date === this.state.selectedDay),
            x => parseInt(x.number, 10)
        );
    _createStage = data => this.props.createStage(this.props.eventId, data);
    _updateStage = data => this.props.updateStage(this.props.eventId, data);
    // PERFORMANCES
    _newPerformance = s => {
        this.props.onInput(MODELS.ENTRY, 'stageIdentifier', `${s.id}_${s.date}`);
        this.props.onInput(MODELS.ENTRY, 'start', timeToMs(s.date, 36000000));
        this.props.onInput(MODELS.ENTRY, 'end', timeToMs(s.date, 39600000));
        this.setState({ showPerformanceDetails: true });
    };
    _editPerformance = p => {
        this.props.setModelData(MODELS.ENTRY, lineupSelectors.performanceToState(p));
        this.setState({ showPerformanceDetails: true });
    };
    _cancelPerformance = () => {
        this.setState({ showPerformanceDetails: false });
        this.props.reset(MODELS.ENTRY);
    };
    _inputPerformance = (value, name) => this.props.onInput(MODELS.ENTRY, name, value);
    _fetchEntryDependencies = () => {
        this.props.fetchEntryDependencies(this.props.eventId, this.props.contextId);
        if (accessToClearance(this.props.user, this.props.contextId)) {
            this.props.fetchAllTemplates(this.props.contextId);
        }
        this.props.fetchArtistContactDependencies(this.props.event.organizationId);
    };
    _submitEntry = () => {
        this.props.submitEntry(this.props.performanceData, () => this._cancelPerformance());
    };
    _deleteEntry = (id, done) => {
        this.props.deleteEntry(id, () => {
            done();
            this._cancelPerformance();
        });
    };
    _search = e => this.setState({ search: e.target.value });
    _listViewEntries = () => {
        return filter(this.props.listViewEntries, e => e.stageDate === this.state.selectedDay);
    };
    _filteredEntries = () => {
        let filteredEntries = [];
        const filteredArtists = this.props.artistOptions
            .filter(x => x.label.toLowerCase().includes(this.state.search.toLowerCase()))
            .map(x => x.value);
        const filteredStages = this.props.stageOptions
            .filter(x => x.label.toLowerCase().includes(this.state.search.toLowerCase()))
            .map(x => x.value.split('_')[0]);
        forEach(this.props.stages, s => {
            s.performances.forEach(p => {
                if (filteredStages.includes(s.id) || filteredArtists.includes(p.artistId)) {
                    filteredEntries.push({ ...p, stageName: s.name });
                }
            });
        });
        return uniqBy(filteredEntries, x => x.id);
    };
    _selectAll = () => this.props.selectAllPerformances(this._listViewEntries().map(lve => lve.id));
    _selectionActions = ['SET LIVE STATE', 'SET NON LINEAR', 'SET USE UNTIL DATE', 'SET COMMENTS'];
    _selectionFunctions = [
        this.props.setAllLive,
        this.props.setAllNonLinear,
        this.props.setAllUntil,
        this.props.setAllComments
    ];
    render() {
        const intervals = getDayIntervals(this.props.event.start, this.props.event.end);
        return (
            <div
                className={`ckp-admin-lineup-editor u-full-height ${
                    this.state.showPerformanceDetails ? 'is-dark' : ''
                }`}
            >
                <AdminModalForm
                    fetchDependencies={this.props.fetchBulkPerformancesDependency}
                    modelId={this.props.eventId}
                    createAction={this.props.bulkUpdatePerformances}
                    title={`Fill in values to bulk edit ${this.props.selectedEntries.length} ${
                        this.props.selectedEntries.length > 1 ? 'entries' : 'entry'
                    }.`}
                    fields={BulkPerformancesInput}
                    model={MODELS.BULK_PERFORMANCE}
                />
                {this.state.showPerformanceDetails ? null : (
                    <h1 className="ckp-ts-h1 ckp-admin-lineup-editor-title">
                        {this.props.event.name}
                        <Link target="_blank" to={TIMETABLE_PATH.replace(':id', this.props.eventId)}>
                            <LaunchIcon style={{ fontSize: '30px' }} />
                        </Link>
                    </h1>
                )}
                {this.state.showDatesForm ? (
                    <DatesSelector
                        loading={this.props.submittingDates}
                        end={this.props.event.end}
                        start={this.props.event.start}
                        setDates={this._setDates}
                        selectDate={this._selectDate}
                    />
                ) : this.state.showPerformanceDetails ? (
                    <PerformancesDetails
                        contextId={this.props.contextId}
                        organizationId={this.props.event.organizationId}
                        fetchSigningUsers={this.props.fetchContractSigningUsers}
                        eventName={this.props.event.name}
                        blockTabSwitch={this.props.blockTabSwitch}
                        enableTabSwitch={this.props.enableTabSwitch}
                        eventId={this.props.eventId}
                        delete={this._deleteEntry}
                        setClearing={this.props.formSetField}
                        dependencies={this.props.dependencies}
                        submit={this._submitEntry}
                        canSubmit={this.props.canSubmitPerformance}
                        stages={this.props.stageOptions}
                        artists={this.props.artistOptions}
                        onInput={this._inputPerformance}
                        cancel={this._cancelPerformance}
                        data={this.props.performanceData}
                        fetchDependencies={this._fetchEntryDependencies}
                        loading={this.props.fetchingDependencies || this.props.isSubmitting || this.props.fetchingModel}
                        shouldFetchDependencies={!this.props.fetchingDependencies && !this.props.fetchedDependencies}
                    />
                ) : (
                    <div className="ckp-admin-lineup">
                        {!this.state.search && (
                            <LineupActions
                                toEditMode={this._toggleEditDatesMode}
                                switchDay={this._switchDay}
                                selected={this.state.selectedDay}
                                days={intervals}
                                toggleListView={this.props.toggleListView}
                                isListView={this.props.isListView}
                            />
                        )}
                        <ActionBar
                            selection={this.props.selectedEntries}
                            selectionActions={this._selectionActions}
                            selectionFunctions={this._selectionFunctions}
                            searchString={this.state.search}
                            search={this._search}
                            enableSearch={true}
                        />
                        {this.state.search ? (
                            <LineupSearchResults
                                results={this._filteredEntries()}
                                editPerformance={this._editPerformance}
                            />
                        ) : this.props.fetchingLineup ? (
                            <Loading className="u-margin-3" label="Fetching stages..." size={40} />
                        ) : this.props.isListView ? (
                            <ListView
                                isAdmin
                                selectAllChecked={
                                    this.props.selectedEntries.length &&
                                    this.props.selectedEntries.length === this._listViewEntries().length
                                }
                                selectAll={this._selectAll}
                                selectedEntries={this.props.selectedEntries}
                                selected={this.props.selected}
                                onSelect={this.props.selectPerformance}
                                user={this.props.user}
                                showEntry={this._editPerformance}
                                entries={this._listViewEntries()}
                                sortBy={this.props.sortBy}
                                order={this.props.order}
                                setFilter={this.props.lineupUpdate}
                            />
                        ) : (
                            <StageEditor
                                organizationId={this.props.event.organizationId}
                                deleteStage={this.props.deleteStage}
                                closeModalForm={this.props.closeModalForm}
                                newPerformance={this._newPerformance}
                                editPerformance={this._editPerformance}
                                eventId={this.props.eventId}
                                shouldFetchLineup={this.props.shouldFetchLineup}
                                fetchingLineup={this.props.fetchingLineup}
                                fetchLineup={this.props.fetchLineup}
                                createStage={this._createStage}
                                updateStage={this._updateStage}
                                intervals={intervals}
                                artists={this.props.artistOptions}
                                openStageForm={this._openStageForm}
                                stages={this._stages()}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    listViewEntries: lineupSelectors.listViewEntriesSelector(state),
    performanceData: formSelectors.formDataSelector(state, { model: MODELS.ENTRY }),
    canSubmitPerformance: formSelectors.canSubmit(state, { model: MODELS.ENTRY }),
    fetchingDependencies: formSelectors.fetchingDependenciesSelector(state),
    fetchedDependencies: formSelectors.fetchedDependenciesSelector(state),
    isSubmitting: formSelectors.submittingSelector(state),
    dependencies: formSelectors.dependenciesSelector(state),
    artistOptions: artistOptionsSelector(state),
    stageOptions: lineupSelectors.stageOptionsSelector(state),
    shouldFetchLineup: lineupSelectors.shouldFetchLineupSelector(state),
    fetchingLineup: lineupSelectors.fetchingLineupSelector(state),
    stages: lineupSelectors.stagesSelector(state),
    entries: lineupSelectors.entriesSelector(state),
    isListView: lineupSelectors.isListViewSelector(state),
    contextId: contextSubjectSelector(state),
    submittingDates: submittingSelector(state),
    event: formSelectors.formDataSelector(state, { model: MODELS.EVENT }),
    sortBy: lineupSelectors.sortBySelector(state),
    order: lineupSelectors.orderSelector(state),
    user: currentUserSelector(state),
    selectedEntries: lineupSelectors.selectedEntriesSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            ...lineupActions,
            onInput,
            blockTabSwitch,
            bulkUpdatePerformances,
            enableTabSwitch,
            setDates,
            formSetField,
            formUpdate,
            openModalForm,
            closeModalForm,
            setModelData,
            reset,
            fetchArtistContactDependencies,
            fetchAllTemplates,
            openModalFormWithData,
            fetchBulkPerformancesDependency
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LineupEditor);
